import { analyticsManager } from './AnalyticsManager';
import analyticsPlugin from './AnalyticsPlugin';
import googleAnalyticsPlugin from './GoogleAnalyticsPlugin';
import facebookPlugin from './FacebookPlugin';
import googleAdsPlugin from './GoogleAdsPlugin';
import hotjarPlugin from './HotjarPlugin';
import clarityPlugin from './ClarityPlugin';
import helpScoutPlugin from './HelpScoutPlugin';
import initialState from '@/InitialState';

const config = initialState.analyticsConfig;
const plugins = [];

if (config?.internalAnalyticsEnabled) {
    plugins.push(analyticsPlugin({}));
}

if (config?.googleAnalytics) {
    plugins.push(googleAnalyticsPlugin(config));
}

if (config?.facebookPixel) {
    plugins.push(facebookPlugin(config));
}

if (config?.googleAds) {
    plugins.push(googleAdsPlugin(config));
}

if (config?.hotjar) {
    plugins.push(hotjarPlugin(config.hotjar));
}

if (config?.clarity) {
    plugins.push(clarityPlugin(config.clarity));
}

if (config?.helpScout) {
    plugins.push(helpScoutPlugin(config.helpScout));
}

const analytics = analyticsManager({
    plugins,
});

export default analytics;
